<div class="card">
    <div class="card-header d-flex align-tems-center justify-content-between">
        <div>
            <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
                @if (expanded) {
                <span class="dripicons-chevron-up"></span>
                }
                @if (!expanded) {
                <span class="dripicons-chevron-down"></span>
                }
            </button>
            General @if (data['name'] !== null) {
            <span class="ml-2 text-dark">{{data['name']}} {{data['dealerNumber']}}</span>
            }
        </div>
        <button class="btn btn-sm btn-primary float-right" id="btn-save-generalInformation" (click)="save()" [disabled]="information.invalid || loading">
            @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
            {{ words[language][ 'save' ] }}</button>
    </div>
    <!-- body individual -->
    @if (expanded) {
    <div>
        <div class="card-body">
            <div class="row text-dark">
                <div class="col-md-12">
                    <form [formGroup]="information">
                        <div class="row">
                            <div class="form-group col-md-4 col-sm-12" title="The name of the company goes here.">
                                <label for="companyName">{{ words[language][ 'companyName' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="companyName" formControlName="companyName" autocomplete="off">
                                @if (companyName.invalid && companyName.dirty) {
                                <span class="text-danger">{{ words[language][
                                    'invalidName'
                                    ] }}</span>
                                }
                            </div>
                            <!-- DBA Name input-->
                            <div class="form-group col-md-4 col-sm-12" title="The doing-business-name, if any, of the company goes here.">
                                <label for="GI_DBAName">{{ words[language][ 'dbaName' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="GI_DBAName" formControlName="dbaName" autocomplete="off">
                                @if (dbaName.invalid && dbaName.dirty) {
                                <span class="text-danger">{{
                                    words[language][
                                    'invalidName' ] }}</span>
                                }
                            </div>
                            <!-- Dealer Number input-->
                            <div class="form-group col-md-4 col-sm-12" title="The state ID that is given to you when you register as a dealer goes here.">
                                <label for="middleName">GDN*</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="GI_dealerNumber" formControlName="dealerNumber" autocomplete="off">
                                @if (dealerNumber.invalid && dealerNumber.dirty) {
                                <span class="text-danger">{{
                                    words[language][ 'invalidNumber' ] }}</span>
                                }
                            </div>
                            <!-- EIN input -->
                            <div class="form-group col-md-4 col-sm-12" title="The ID that is given to you when you register your company.">
                                <label for="einNumber">{{ words[language][ 'einNumber' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="einNumber" formControlName="einNumber" autocomplete="off">
                                @if (einNumber.invalid && einNumber.dirty) {
                                <span class="text-danger">{{
                                    words[language][
                                    'invalidNumber' ] }}
                                </span>
                                }
                            </div>
                            <!-- First Name input-->
                            <div class="form-group col-md-4 col-sm-12" title="The person that is the main contact for this location.">
                                <label for="GI_firstName">{{ words[language][ 'contactFirstName' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="GI_firstName" formControlName="firstName" autocomplete="off">
                                @if (firstName.invalid && firstName.dirty) {
                                <span class="text-danger">{{
                                    words[language][
                                    'InvalidfirstName' ] }}</span>
                                }
                            </div>
                            <!-- lastName input-->
                            <div class="form-group col-md-4 col-sm-12" title="The person that is the main contact for this location.">
                                <label for="GI_lastName">{{ words[language][ 'contactLastName' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="GI_lastName" autocomplete="off" formControlName="lastName">
                                @if (lastName.invalid && lastName.dirty) {
                                <span class="text-danger">{{
                                    words[language][
                                    'InvalidLastName' ] }}</span>
                                }
                            </div>
                            @if (type=='lot') {
                            <div class="form-group col-md-4 col-sm-12" title="Select the timezone for the location.">
                                <label for="tzId">Timezone</label>
                                <select name="tzId" id="tzId" class="form-control form-control-sm col-sm-12" formControlName="tzId">
                                    @for (zone of timezones; track zone.id) {
                                        <option [value]="zone.id">{{zone.name}} ({{zone.abbrev}})</option>
                                    }
                                </select>
                            </div>
                            }
                            <div class="form-group col-md-4 col-sm-12" title="Website for this location.">
                                <label for="GI_website">{{ words[language][ 'website' ] }}</label>
                                <input class="form-control form-control-sm text-dark" type="text" id="GI_website" autocomplete="off" formControlName="website">
                                @if (website.invalid && website.dirty) {
                                <span class="text-danger">{{
                                    words[language][
                                    'website' ] }}</span>
                                }
                            </div>
                            @if (type=='lot') {
                            <div class="form-group col-md-4 col-sm-12" title="Change the parent dealership of this lot here.">
                                <label for="dealership">Parent Dealership</label>
                                <select name="dealership" id="dealership" class="form-control form-control-sm col-sm-12" formControlName="dealershipId">
                                    @for (dealership of dealershipList; track dealership) {
                                    <option [value]="dealership.id">{{dealership.contact.name}}
                                    </option>
                                    }
                                </select>
                            </div>
                            }
                        </div>
                        <div class="row">
                            @if (type=='corporation') {
                            <div class="col-md-6">
                                <div class="card shadow-none">
                                    <h5 class="card-header">Logo</h5>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6" [ngClass]="{'d-none' : information.get('corporateLogoURL').value == null}">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input" (change)="toggleDisplay(!!information.get('displayLogoInternal').value)" formControlName="displayLogoInternal">
                                                    <label class="form-check-label" for="customCheck1">Display on
                                                        AutoAction</label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="file-upload w-100 d-flex align-items-center justify-content-center">
                                                    <div class="image-upload-wrap w-100" [ngClass]="{'d-none' : information.get('corporateLogoURL').value !== null}">
                                                        <input class="file-upload-input" id="image-upload-input" type='file' [accept]="supportedExtensions" (change)="changeImage($event)" />
                                                        <div class="drag-text">
                                                            <span class="h1 text-muted dripicons-cloud-upload"></span>
                                                            <h3 class="text-muted">{{words[language][ 'uploadImages' ]
                                                                }}
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <img [src]="information.get('corporateLogoURL').value" [ngClass]="{'d-none' : information.get('corporateLogoURL').value == null}" alt="" class="img-fluid" width="200">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <button role="button" class="btn btn-outline-danger float-right" (click)="removeImage()" [disabled]="loading" [ngClass]="{'d-none' : information.get('corporateLogoURL').value == null}">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    }
</div>
